<!--
    @Author : Luo
    @Time   : 2020/12/2 12:05
-->
<template>
  <div class="modal_dialog" v-if="visible">
    <div class="modal_container">
      <div class="modal_header flex_center">
        <div class="modal_header_text"><span>{{ headerTitle }}</span></div>
        <div class="modal_close" @click="close">
          <svg-icon className="icon_down_style svg_icon_sm color_102 pointer_none" iconClass="icon_close"></svg-icon>
        </div>
      </div>
      <div class="modal_content">
        <slot name="modal_content"></slot>
      </div>
      <div class="modal_footer">
        <div class="modal_footer_default flex_center" v-if="isFooter">
          <div class="modal_cancel" @click="close">
            <span>{{ modalCancelText }}</span>
          </div>
          <div class="modal_save" @click="save">
            <span>{{ modalOkText }}</span>
          </div>
        </div>
        <slot name="modal_footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  data () {
    return {
    }
  },
  props: {
    // 数据的总长度
    faVisible: {
      type: Boolean
    },
    headerTitle: {
      type: String
    },
    isFooter: {
      type: Boolean
    },
    modalCancelText: {
      type: String,
      default: '取消'
    },
    modalOkText: {
      type: String,
      default: '确定'
    }
  },
  computed: {
    visible: function () {
      return this.faVisible
    }
  },
  methods: {
    close: function () {
      this.$emit('mmodal_close')
    },
    save: function () {
      this.$emit('mmodal_ok')
    },
    // 传播事件
    modalOk: function (v) {
      this.$emit('ok', {event: v, amount: this.amount})
    }
  },
  beforeMount () {
  }
}
</script>

<style scoped>
.modal_dialog {position: fixed;top: 0;;left: 0;width: 100%;height: 100%;overflow: hidden;background: rgba(0, 0, 0, .3);display: flex;justify-content: center;align-items: center}
.modal_container {padding: 24px 0;width: 650px;background: #FFFFFF;box-shadow: 0px 4px 16px 0px rgba(96, 96, 96, 0.14);border-radius: 6px;}
.modal_header {justify-content: space-between;padding: 0 24px}
.modal_content {margin-top: 20px;padding: 0 24px}
.modal_close {cursor: pointer}
.modal_footer {padding: 16px 0 0}
.modal_footer_default {padding: 16px 24px 0;justify-content: flex-end;border-top: 1px solid rgba(235, 235, 235, 1)}
.modal_footer_default div {border-radius: 4px;cursor: pointer;width: 80px;height: 32px;line-height: 32px;text-align: center;border: 1px solid rgba(219, 219, 219, 1);background: rgba(255, 255, 255, 1)}
.modal_footer_default span {font-size: 14px;font-weight: 400;color: rgba(96, 96, 96, 1)}
.modal_footer_default .modal_save {margin-left: 10px;border: 1px solod rgba(101, 150, 235, 1);background: rgba(101, 150, 235, 1)}
.modal_footer_default .modal_save span {color: rgba(255, 255, 255, 1)}
</style>



// WEBPACK FOOTER //
// src/components/modal/index.vue